import { ifcLoader } from "../viewer/scene";

export function getIfcName(props: any): string {
  const raw = props?.Name;
  if (typeof raw === "string") {
    return raw;
  }
  if (raw && typeof raw === "object") {
    if (typeof raw.value === "string") {
      return raw.value;
    }
    if (typeof raw.Value === "string") {
      return raw.Value;
    }
  }
  return "Без имени";
}

export function unwrapIfcValue(raw: any): string {
  if (raw === null || raw === undefined) {
    return "";
  }
  if (typeof raw === "string" || typeof raw === "number" || typeof raw === "boolean") {
    return String(raw);
  }
  if (typeof raw === "object") {
    if ("value" in raw && raw.value !== undefined && raw.value !== null) {
      return String(raw.value);
    }
    if ("Value" in raw && raw.Value !== undefined && raw.Value !== null) {
      return String(raw.Value);
    }
  }
  return "";
}

export async function getAdskNameValue(modelId: number | string, expressId: number): Promise<string> {
  try {
    const propertySets = (await ifcLoader.ifcManager.getPropertySets(modelId, expressId, true)) as any[];
    for (const pset of propertySets || []) {
      const properties = (pset?.HasProperties || []) as any[];
      for (const prop of properties) {
        const propName = unwrapIfcValue(prop?.Name);
        if (propName !== "ADSK_Наименование") {
          continue;
        }
        const nominal = prop?.NominalValue ?? prop?.Nominalvalue ?? prop?.Value;
        const value = unwrapIfcValue(nominal);
        return value || "—";
      }
    }
  } catch (_) {
    // ignore and fallback
  }
  return "—";
}

export function getElementMark(props: any): string {
  const tag = props?.Tag;
  if (typeof tag === "string") {
    return tag;
  }
  if (tag && typeof tag === "object") {
    if (typeof tag.value === "string") {
      return tag.value;
    }
    if (typeof tag.Value === "string") {
      return tag.Value;
    }
  }
  return getIfcName(props);
}
